import React from 'react';
import Icon from "../../../components/Icon";
import {Link, withRouter} from "react-router-dom";

const RoomHeader = ({
                        room = {},
                        mobile = false,
                        ...props
                    }) => {
    return (
        <div className="chat-header">
            {!!mobile && (
                <div className={"responsive-btn"}
                     onClick={() => props.history.goBack()}><Icon type={"arrow-left"}/>
                </div>
            )}
            <div className={"column chat-header-container"}>
                <div className="row">
                    {room.groupName !== "" ? (<h3 className="title"><span>{room.groupName}</span></h3>) : (
                        <h3 className="title">En chat avec
                            {room.participantsWithoutCurrent.map((users, index) => {
                                return (
                                    <span key={index}>&nbsp;{users.username}</span>
                                )
                            })}
                        </h3>)}
                </div>
                <div
                    className={`status-dot ${room.hasUserOnline ? 'online' : 'offline'}`}>{room.hasUserOnline ? 'en ligne' : 'hors-ligne'}</div>
            </div>
            {!!mobile && (
                <Link className={"responsive-btn"} to={`${props.match.url}/infos`}>
                    <Icon type={"info"}/>
                </Link>
            )}
        </div>
    )
};


export default withRouter(RoomHeader);
